import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from "@angular/router";
import {AddReportsComponent} from "../components/reports/add-reports/add-reports.component";
import {Observable} from "rxjs";

@Injectable()
export class CanDeactivateAddReportsService implements CanDeactivate<AddReportsComponent>{

  constructor() { }

  canDeactivate(component: AddReportsComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (component.reportsToDescribe() > 0)
      return window.confirm('Istnieją raporty do opisania. Czy jesteś pewna/pewien, że chcesz zrezygnować ?');

    return true;
  }
}
